module.exports = __webpack_public_path__ + "static/media/ariaLogo.cfc88304.svg";